// @flow
import styled from 'styled-components';
import { below } from '../../assets/css/media';
import colors from '../../assets/css/colors';
import { TableFlexCell } from "./TableFlexCell";

export const PlayerTableCell = styled(TableFlexCell)`
	height: ${({ height }) => height || '60px'};
	position: relative;
	${below.desktop`
		height: 50px;
	`}

	.live {
		display: flex;
		align-items: center;
		justify-content: center;
		color: #fff;
		background: ${colors.liveGreen};
		width: 30px;
		height: 20px;
		border-radius: 15px;
		font-weight: bold;
		font-size: 12px;
	}
`;

export default PlayerTableCell;


// WEBPACK FOOTER //
// ./src/components/Table/PlayerTableCell.js